<template>
  <div
    class="md-layout container"
  >
    <template v-for="(image, key) in images">
      <div
        :key="key"
        class="studio-piece md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-25 md-small-size-40 md-xsmall-size-100"
        :style="imgSize"
        :class="{'active': currentIndex === key}"
        @click="updateIndex(key)"
      >
        <img :src="image">
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'StudioProjectPieces',
  props: {
    images: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      timer: null,
      currentIndex: this.index
    }
  },
  computed: {
    currentImg() {
      return this.images[Math.abs(this.currentIndex) % this.images.length]
    },
    imgSize() {
      return {
        height: `200px`
      }
    }
  },
  watch: {
    index (value) {
      this.currentIndex = value
    }
  },
  methods: {
    updateIndex (key) {
      this.$emit('current-index', key) 
      this.$emit('current-image', this.images[key])
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-top: 20px;
  .active {
    border: 2px solid $color-primary;
  }
  .studio-piece {
    cursor: pointer;
    &:not(:last-child) {
      margin-right: 36px;
    }
    margin-bottom: 30px;
  }
}
 img {
  width:100%;
  height:100%;
}
</style>